import { render, staticRenderFns } from "./LanguageEditModal.vue?vue&type=template&id=a590d9b8&scoped=true"
import script from "./LanguageEditModal.vue?vue&type=script&lang=js"
export * from "./LanguageEditModal.vue?vue&type=script&lang=js"
import style0 from "./LanguageEditModal.vue?vue&type=style&index=0&id=a590d9b8&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a590d9b8",
  null
  
)

export default component.exports